// extracted by mini-css-extract-plugin
export default {"hideTooltip":"M--z","fadeIn":"N--z","delay":"O--z","recommendedSizeTooltip":"P--z"};